import React, { useState } from "react";
import classes from './Collapse.module.css';


const Collapse = ({ title, content }) => {

    const [showContent, setShowContent] = useState()

    return (
        <>
            <div className={classes.CollapseContainer}>
                <button className={classes.ButtonContainer} onClick={(e) => { e.stopPropagation(); setShowContent(!showContent) }}>
                    <div className={`${classes.Circle} ${showContent ? classes.MinusCircle : classes.PlusCircle}`}>
                        <div className={classes.Minus}></div>
                        {!showContent && <div className={classes.Plus}></div>}
                    </div>
                    <p className={classes.Title}>{title}</p>
                </button>
                {showContent && <p className={classes.Content}>{content}</p>}
            </div>
            <div className={classes.Line}></div>
        </>
    )
}
export default Collapse;